import React from "react";
import { Capacitor } from "@capacitor/core";
import PassesWeb from "./PassesWeb";
import PassesApp from "./PassesApp";

export default function Passes() {
    const isNative = Capacitor.isNativePlatform() || import.meta.env.VITE_NATIVE_APP === "true";
    return isNative ? <PassesApp /> : <PassesWeb />;
}
